/**
 * Utility functions for date and time calculations
 */

export interface DateTimeParams {
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
}

/**
 * Adjusts end date for cross-midnight scenarios
 * When end time is earlier than or equal to start time, it means the booking crosses midnight
 */
export function adjustCrossMidnightDate(params: DateTimeParams): DateTimeParams {
  const { startDate, endDate, startTime, endTime } = params;
  
  // If end time is earlier than or equal to start time, adjust end date to next day
  if (endTime <= startTime) {
    const nextDay = new Date(startDate);
    nextDay.setDate(nextDay.getDate() + 1);
    const adjustedEndDate = nextDay.toISOString().split('T')[0];
    
    return {
      startDate,
      endDate: adjustedEndDate,
      startTime,
      endTime
    };
  }
  
  // No adjustment needed
  return params;
}